import request from "@/API/request";

export function uploadVoiceMessage(formData) {
    return request({
        url: `/auth/api/customer-service/upload-audio`,
        method: 'post',
        data: formData,
    });
}
